var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"flex w-full mb-12 mt-12",staticStyle:{"border-bottom":"1px solid #B7BDCD"}},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.id,class:[
      'flex',
      'items-center',
      'justify-center',
      'custom-tab',
      tab.id === _vm.currentTab ? 'custom-tab__active' : 'custom-tab__inactive',
    ],on:{"click":function($event){return _vm.$emit('current-tab', tab.id)}}},[_vm._v(" "+_vm._s(tab.value)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }